import React from 'react';
import { Video } from 'lucide-react';
export function FormsVideosHero() {
  return <section className="bg-gradient-to-br from-slate-900 to-slate-800 text-white py-20" data-id="element-164">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-165">
        <div className="inline-flex items-center justify-center p-3 bg-white/10 rounded-full mb-6" data-id="element-166">
          <Video className="h-6 w-6 text-[#dc2626]" data-id="element-167" />
        </div>

        <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-168">Forms & Videos</h1>

        <p className="text-lg text-slate-200 max-w-2xl mx-auto" data-id="element-169">
          Access our complete library of form instructional videos. Learn and
          practice each form at your own pace with detailed demonstrations from
          our instructors.
        </p>
      </div>
    </section>;
}